import dayjs from "dayjs";

function formatDateValue(value: unknown, pattern: string): string {
  if (
    (typeof value !== "string" && typeof value !== "number" && !(value instanceof Date)) ||
    (typeof value === "string" && !value.trim())
  ) return "-";
  const date = dayjs(value);
  return date.isValid() ? date.format(pattern) : "-";
}

export function formatDateTime(value: unknown): string {
  return formatDateValue(value, "YYYY-MM-DD HH:mm:ss");
}

export function formatDate(value: unknown): string {
  return formatDateValue(value, "YYYY-MM-DD");
}
